import React from "react";

export default function Footer() {
    return (
        <div className="footer">
            <footer>Made by Bernardo Semiao 2023©</footer>
            <a href="https://semiao.netlify.app/">visit for more info</a>
        </div>
    )
}
